(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('stored-document-stats', {
                parent: 'entity',
                url: '/stored-document-stats',
                data: {
                    authorities: ['ROLE_SUPER_ADMIN'],
                    pageTitle: 'Statistiques S3'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/business/stored-document-stats/stored-document-stats.html',
                        controller: 'StoredDocumentStatsController',
                        controllerAs: 'vm'
                    }
                }
            });
    }
})();
